/**
 * @desc 根据店铺id平台店铺ID店铺关系关联表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlatformSiteShopRelevanceResponseDto>;
export function request(
  params: API.basics.platformSiteShopRelevance.listBySiteShopId.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformSiteShopPlatformSiteShopController/listBySiteShopId`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
